"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var view_element_branch_resolver_1 = require("../../sis-tabular-report-options/resolver/view-element-branch-resolver");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var BranchIndexRegulator = /** @class */ (function () {
    function BranchIndexRegulator() {
    }
    /**
     * Calculates and stores the branch index state for each column view
     *
     * @param {ColumnView} node
     * @param {ViewElementBranchResolver} viewElementBranchResolver
     * @param {string} key
     */
    BranchIndexRegulator.prototype.calculateAndStoreBranchIndexes = function (node, key) {
        if (!node.isNew && !node.isDefaultNew && node.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            node.setCalculatedValue(key, view_element_branch_resolver_1.ViewElementBranchResolver.getColumnElementBranchIndex(node));
        }
        for (var i = 0; i < node.children.length; i++) {
            this.calculateAndStoreBranchIndexes(node.children[i], key);
        }
    };
    /**
     * Constructs a map representing the changes of branchIndexes after removing, adding or moving columns
     *
     * @param {Map<number, number>} branchIndexesChange
     * @param {ColumnView} node
     * @param {string} keyBefore
     * @param {string} keyAfter
     */
    BranchIndexRegulator.prototype.constructDifferenceMap = function (branchIndexesChange, node, keyBefore, keyAfter) {
        // set value difference
        var valueBefore = node.getCalculatedValue(keyBefore);
        var valueAfter = node.getCalculatedValue(keyAfter);
        if (valueBefore !== undefined) {
            branchIndexesChange.set(valueBefore, valueAfter);
        }
        // remove calculated values from tree node
        node.removeCalculatedValue(keyBefore);
        node.removeCalculatedValue(keyAfter);
        // do the same for all children
        for (var i = 0; i < node.children.length; i++) {
            this.constructDifferenceMap(branchIndexesChange, node.children[i], keyBefore, keyAfter);
        }
    };
    return BranchIndexRegulator;
}());
exports.BranchIndexRegulator = BranchIndexRegulator;
//# sourceMappingURL=branch-index-regulator.js.map